import { QueryClient } from "@tanstack/react-query";

// Server-State-Layer (§4). TanStack Query cached die API-Reads (folders/assets/jobs/
// credits) und invalidiert sie nach Submit / Live-Status-Push. Knappe Defaults: kein
// aggressives Refetch (Live-Status liefert Job-Updates per Push, D47).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const qk = {
  folders: ["folders"] as const,
  assets: (folderId: string | null) => ["assets", folderId ?? "inbox"] as const,
  jobs: ["jobs"] as const,
  jobPreviews: ["job-previews"] as const,
  credits: ["credits"] as const,
  job: (id: string) => ["job", id] as const,
  apiKeys: ["api-keys"] as const,
};
